import React, { useEffect, useRef } from 'react';

const FogyasztoBaratEmbed = ({ dataType }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Only run on the actual production domain to avoid CORS/runtime errors in preview
    const hostname = window.location.hostname;
    if (hostname !== 'akonyhad.hu' && hostname !== 'www.akonyhad.hu') {
      console.log(`[Preview Mode] Fogyasztó Barát (${dataType}) script skipped. Only runs on akonyhad.hu.`);
      if (containerRef.current) {
         containerRef.current.innerHTML = `<div class="p-12 text-center text-muted-foreground border border-dashed border-border/60 uppercase tracking-widest text-xs">Fogyasztó Barát widget (${dataType}) placeholder<br/>(Csak az éles akonyhad.hu domainen töltődik be)</div>`;
      }
      return;
    }

    const container = containerRef.current;
    if (!container) return;

    // Prevent duplicate injection
    if (document.getElementById('fbarat-embed')) {
      document.getElementById('fbarat-embed').remove();
    }
    
    container.innerHTML = ''; // Clear prior elements

    const dummyScript = document.createElement('script');
    dummyScript.id = 'barat_script';
    container.appendChild(dummyScript);

    const st = document.createElement("script");
    st.src = "//admin.fogyasztobarat.hu/e-api.js";
    st.type = "text/javascript";
    st.setAttribute("data-id", "63V3CLSM");
    st.setAttribute("id", "fbarat-embed");
    st.setAttribute("data-type", dataType);
    
    // Exact logic requested: s.parentNode.insertBefore(st, s)
    const s = document.getElementById("barat_script");
    if (s && s.parentNode) {
        s.parentNode.insertBefore(st, s);
    }

    return () => {
      const existingScript = document.getElementById('fbarat-embed');
      if (existingScript) existingScript.remove();
    };
  }, [dataType]);

  return (
    <div 
      ref={containerRef} 
      className="w-full bg-transparent min-h-[30vh] my-8" 
    />
  );
};

export default FogyasztoBaratEmbed;
